import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/bookmark-minus.vue
var o = {
	name: "DtIconBookmarkMinus",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--bookmark-minus"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Bookmark Minus",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M3.5 2a.5.5 0 0 0-.5.5v7.138l2.752-1.572a.5.5 0 0 1 .496 0L9 9.638V2.5a.5.5 0 0 0-.5-.5h-5Zm-1.06-.56A1.5 1.5 0 0 1 3.5 1h5A1.5 1.5 0 0 1 10 2.5v8a.5.5 0 0 1-.748.434L6 9.076l-3.252 1.858A.5.5 0 0 1 2 10.5v-8c0-.398.158-.78.44-1.06Z",
		"clip-rule": "evenodd"
	}, null, -1), r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M4 5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 4 5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=bookmark-minus.js.map